// peticiones a backend
import axios from 'axios';
import { logout } from '../actions/user';
import { basicMsg } from '../actions/swal_msg';
import { couponRequestOptions } from './shop/couponSession';
const withCouponContext = (endpoint, obj) => (endpoint.startsWith('shop/cart/') || endpoint.startsWith('payment/'))
    ? { ...couponRequestOptions(), ...obj } : obj;

const base_url = process.env.REACT_APP_NEFRO_API_URL; // servidor en Node.js (peticiones - MongoDB)
const nefro_url = process.env.REACT_APP_API_NEFROPOLIS_URL; // API de Nefrópolis (dirección; cp, colonia, ciudad, estado)

// peticiones de aplicación
const request = (endpoint, obj, method = 'GET') => {
    const url = `${base_url}/${endpoint}`;
    if (method === 'GET') {
        return fetch(url, { method });
    } else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(withCouponContext(endpoint, obj))
        });
    }
};

// petición restringida (sólo administradores)
const protectedReq = (endpoint, obj, method = 'GET') => {
    const url = `${base_url}/${endpoint}`;
    // token guardado
    const token = localStorage.getItem('token') || '';
    if (method === 'GET') {
        return fetch(url, {
            method,
            headers: {
                'x-token': token
            }
        });
    } else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
                'x-token': token
            },
            body: JSON.stringify(withCouponContext(endpoint, obj))
        });
    }
};

// FormData: el navegador agrega automáticamente el boundary de multipart.
const protectedFormReq = (endpoint, form, method = 'POST') => {
    const url = `${base_url}/${endpoint}`;
    const token = localStorage.getItem('token') || '';
    return fetch(url, {
        method,
        headers: { 'x-token': token },
        body: form
    });
};

// petición mejorada para cerrar sesión si ha expirado el token de usuario
const protectedFetchReq = async (endpoint, obj = {}, method = 'GET', dispatch) => {
    const url = `${base_url}/${endpoint}`;
    // token de usuario
    const token = localStorage.getItem('token') || '';
    const config = {
        method,
        headers: {
            'x-token': token,
            ...(method !== 'GET' && { 'Content-type': 'application/json' }),
        },
        ...(method !== 'GET' && { body: JSON.stringify(obj) }),
    };
    const resp = await fetch(url, config);
    const body = await resp.json();
    if (!body.status) {
        if (['no-token', 'unavailable-token', 'invalid-token'].includes(body.msg)) {
            dispatch(logout()); // cerrar sesión
            return null;
        }
    }
    return body;
};

const axiosRequest = async(endpoint, data, method = 'GET') => {
    const url = `${base_url}/${endpoint}`;
    const resp = method === 'POST' ?
        await axios.post(url, data)
    :
        await axios.get(url);
    if (resp && resp.data)
        return resp.data;
    basicMsg('Incidente con la petición');
    return { status: false };
};
// petición mejorada para cerrar sesión si ha expirado el token de usuario
// se utiliza al enviar archivos a backend
const protectedAxiosReq = async(endpoint, data, method = 'GET', dispatch) => {
    // token guardado
    const token = localStorage.getItem('token') || '';
    const config = {
        headers: {
            'x-token': token
        }
    };
    try {
        const url = `${base_url}/${endpoint}`;
        const resp = method === 'POST' ?
            await axios.post(url, data, config)
        :
            await axios.get(url, config);
        if (resp) {
            const body = resp.data;
            if (!body.status) {
                if (['no-token', 'unavailable-token', 'invalid-token'].includes(body.msg)) {
                    dispatch(logout()); // cerrar sesión
                    return null;
                }
            }
            return body;
        }
        basicMsg('Incidente con la petición');
        return null;
    } catch (err) {
        basicMsg('Incidente con la petición');
        return null;
    };
};

// petición a api.nefropolis
const nefroRequest = async(endpoint, form, method = 'GET') => {
    const url = `${nefro_url}/${endpoint}`;
    if (method === 'GET') {
        const resp = await axios.get(url);
        return resp;
    } else {
        const resp = await axios.post(url, form);
        return resp;
    }
};

const axiosProtectedReq = async(endpoint, data, method = 'GET') => {
    // token guardado
    const token = localStorage.getItem('token') || '';
    const config = {
        headers: {
            'x-token': token
        }
    };
    try {
        const url = `${base_url}/${endpoint}`;
        const resp = method === 'POST' ?
            await axios.post(url, data, config)
        :
            await axios.get(url, config);
        // if (resp) return resp.data;
        // else return { status: false, msg: 'request-err' };
        return resp.data;
    } catch (err) {
        if (err.response && err.response.data)
            return err.response.data;
        return { status: false, msg: 'request-err' };
    };
};

export {
    request,
    protectedReq,
    protectedFormReq,
    protectedFetchReq,
    protectedAxiosReq,
    axiosRequest,
    nefroRequest,
    axiosProtectedReq
};
